import { useMemo, useState } from "react";
import "./AcoesFormulario.css";
import {
  Modal,
  Button,
  Spinner,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import type { OverlayTriggerType } from "react-bootstrap/esm/OverlayTrigger";

interface AcoesFormularioProps {
  onGerarPagamento?: (opts?: Record<string, unknown>) => Promise<boolean>;
  disableAcoes?: boolean;
  disableGerar?: boolean;
  disableGerarReason?: string;
}

const AcoesFormulario = ({
  onGerarPagamento,
  disableAcoes = false,
  disableGerar = false,
  disableGerarReason,
}: AcoesFormularioProps) => {
  const _disableGerar = disableGerar || disableAcoes;
  const [showModal, setShowModal] = useState(false);
  const [isGerando, setIsGerando] = useState(false);

  const gerarDisabled = _disableGerar || isGerando;

  const tooltipGerar = (
    <Tooltip id="tooltip-gerar-pag">
      {disableGerarReason || "Ação bloqueada."}
    </Tooltip>
  );

  const triggerHoverFocus: OverlayTriggerType[] = ["hover", "focus"];
  const triggerNone: OverlayTriggerType[] = [];

  const gerarClass = useMemo(() => {
    return `btn btn-gerar btn-acao ${_disableGerar ? "btn-acao-disabled" : ""}`;
  }, [_disableGerar]);

  const handleClickGerar = () => {
    if (gerarDisabled) return;
    setShowModal(true);
  };

  const handleConfirmar = async () => {
    if (gerarDisabled || isGerando) return;
    setIsGerando(true);
    try {
      await onGerarPagamento?.({ showSpinner: false });
      setShowModal(false);
    } catch {
      // toast/erro tratado na página
    } finally {
      setIsGerando(false);
    }
  };

  return (
    <div className="acoes-formulario d-flex justify-content-end gap-3 mt-4">
      <OverlayTrigger
        placement="top"
        overlay={tooltipGerar}
        trigger={_disableGerar ? triggerHoverFocus : triggerNone}
      >
        <span className="d-inline-block">
          <button
            type="button"
            className={gerarClass}
            onClick={handleClickGerar}
            disabled={gerarDisabled}
            aria-disabled={gerarDisabled}
          >
            {isGerando ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Gerando
              </>
            ) : (
              "GERAR PAG"
            )}
          </button>
        </span>
      </OverlayTrigger>

      <Modal
        show={showModal}
        onHide={() => (isGerando ? null : setShowModal(false))}
        centered
        backdrop="static"
        keyboard={!isGerando}
      >
        <Modal.Header closeButton={!isGerando}>
          <Modal.Title className="text-primary fw-bold">
            Confirmar GERAR PAG
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="mb-0">
            Ao clicar em &quot;Gerar PAG&quot;, as informações serão geradas no
            sistema. Deseja realmente gerar?
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="danger"
            onClick={() => setShowModal(false)}
            disabled={isGerando}
          >
            Cancelar
          </Button>

          <Button
            className="btn-confirmar d-inline-flex align-items-center justify-content-center gap-2"
            onClick={handleConfirmar}
            disabled={isGerando}
          >
            {isGerando ? (
              <>
                <Spinner animation="border" size="sm" />
                <span>Gerando</span>
              </>
            ) : (
              "Confirmar"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AcoesFormulario;
